import React, { useState, useEffect } from 'react';
import {
  Grid,
  Card,
} from '@mui/material';
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import routes from "trainerRoutes";
import editRoutes from "trainingCompanyEditRoutes";
import Container from "@mui/material/Container";
import Logo from "assets/images/skill2.png";
import MKButton from "components/MKButton";
import { LocationOn, AttachMoney } from '@mui/icons-material';
import MKTypography from "components/MKTypography";
import { useNavigate } from 'react-router-dom';
import Rating from '@mui/material/Rating';
import Stack from '@mui/material/Stack';
import MKAvatar from "components/MKAvatar";
import '../../../styles.css';
import IdleTimeOutHandler from "pages/IdleTimeHandler/IdleTimeOutHander";

const Page = () => {
  // const styles = {
  //   gridItem: {
  //     border: '1px double #ccc',
  //     borderRadius: '30px',
  //     padding: '16px',
  //     marginBottom: '16px',
  //     boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.1)',
  //     width: '500px',
  //     backgroundColor: ({ palette: { white }, functions: { rgba } }) => rgba(white.main, 1.0), backdropFilter: "saturate(200%) blur(30px)", boxShadow: ({ boxShadows: { xxl } }) => xxl,
  //   },
  //   trainingInfo: {
  //     display: 'flex',
  //     flexDirection: 'column',
  //   },
  //   trainingName: {
  //     // marginTop: '10px',
  //     marginBottom: '8px',
  //     fontSize: 'medium',
  //     color: 'rgb(60, 150, 190)',
  //   },
  //   gridContent: {
  //     padding: '8px',
  //   },
  // };
  const [trainingCompanyProfileCreate, setTrainingCompanyProfileCreate] = useState(false);
  const [trainerRecruitDetails, setTrainerRecruitDetails] = useState([]);
  const [avatarBackgroundColor, setAvatarBackgroundColor] = useState('#ccc');

  useEffect(() => {
    let id = localStorage.getItem("userId");
    console.log(id);
    let display = "card"
    fetch(`${process.env.REACT_APP_API_URL}/api/dashboard-company-recruit/${id}/${display}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('token'),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (!data.detail) {
          setTrainerRecruitDetails(data);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);
  console.log("trainerRecruitDetails", trainerRecruitDetails);


  const navigate = useNavigate();

  const onMoreDetailsClick = (training) => {
    console.log("training", training.id);
    navigate(`/app/recruitedtrainermoredetails/${training.trainerRecruitID}/`);
  };

  const onEditClick = (training) => {
    console.log("training", training.id);
    navigate(`/app/activetrainingmoredetails/${training.id}/`);
  };

  const renderTrainerCards = (trainers) => {
    return trainers.map((trainer, index) => (
      <Grid item xs={6} key={trainer.id} >
        <div className="gridItemSeeMore">
          <div className="gridContentSeeMore">
            <div className="trainingInfo">
              <div style={{ fontWeight: 'bold', marginTop: '-5px', marginBottom: '5px', display: 'flex', alignItems: 'center' }}>
                <MKAvatar
                  src={`${process.env.REACT_APP_API_URL}${trainer.profilePictureName}/`}
                  alt="Profile Picture"
                  size="lg"
                  style={{ backgroundColor: avatarBackgroundColor, marginRight: '10px' }}
                />
                <MKTypography variant="subtitle1" className="trainingNameSeeMore" style={{ marginTop: '5px' }}>
                  <strong>{trainer.firstName}&nbsp;{trainer.lastName}</strong>
                </MKTypography>
              </div>
              <MKTypography style={{ fontSize: 'medium' }}>
                <span style={{ display: 'flex', alignItems: 'center' }}>
                  <strong><img src={Logo} alt="Skills Logo" style={{ marginRight: '5px', width: '20px', height: '20px' }} /></strong> {trainer.displaySkills}
                </span>
              </MKTypography>
              <MKTypography style={{ fontSize: 'medium' }}>
                <span style={{ display: 'flex', alignItems: 'center' }}>
                  <LocationOn style={{ marginRight: '5px' }} /> {trainer.currentLocationCountry} | {trainer.currentLocationState}  | {trainer.location}
                </span>
              </MKTypography>
              <MKTypography style={{ fontSize: 'medium' }}>
                <span style={{ display: 'flex', alignItems: 'center' }}>
                  <strong style={{ marginLeft: "5px" }}>Total Experience :&nbsp;</strong>{trainer.totalExperience} months
                </span>
              </MKTypography>
              <MKTypography style={{ fontSize: 'medium' }}>
                <span style={{ display: 'flex', alignItems: 'center' }}>
                  <strong style={{ marginLeft: "5px" }}>Avg per hour Commercial :&nbsp;</strong>{trainer.currency}&nbsp;{trainer.avgCommercialFor8hrs}
                </span>
              </MKTypography>
              <MKTypography style={{ fontSize: 'medium' }}>
                <span style={{ display: 'flex', alignItems: 'center' }}>
                  <strong style={{ marginLeft: '5px', marginBottom: '-3px' }}>Rating</strong>&nbsp;
                  <Stack spacing={1} style={{ marginLeft: '5px' }}>
                    <Rating
                      name="read-only"
                      value={trainer.trainerRating}
                      precision={0.5}
                      readOnly
                    />
                  </Stack>
                </span>
              </MKTypography>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '10px' }}>
              <MKButton variant="gradient" color="info" size="small" onClick={() => onMoreDetailsClick(trainer)} style={{ padding: '5px 10px', alignSelf: 'flex-start' }}>Details</MKButton>
            </div>
          </div>
        </div>
      </Grid>
    ));
  };


  return (
    <>
      <IdleTimeOutHandler />
      <DefaultNavbar
        routes={trainingCompanyProfileCreate ? routes : editRoutes}
        sticky
      />
      <Card
        sx={{
          minHeight: '101vh',
          height: 'auto',
          p: 2,
          mx: { xs: 2, lg: 3 },
          mt: -8,
          mb: 4,
          // backgroundColor: ({ palette: { white }, functions: { rgba } }) => rgba(white.main, 0.8),
          backdropFilter: "saturate(200%) blur(30px)",
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
        }}
      >
        <Container>
          <Grid container>
            <Grid item xs={12} style={{ marginTop: "150px" }}>
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <Grid container spacing={2} style={{ marginBottom: "10px" }}>
                  <Grid item xs={12} style={{ display: 'flex' }}>
                    <MKTypography style={{ whiteSpace: 'nowrap' }} variant="h4" color="text">
                      <span style={{ color: 'black' }}>Recurited</span>{' '}
                      <span style={{ color: '#2e1114' }}>Trainers</span>
                    </MKTypography>
                  </Grid>
                </Grid>

                {trainerRecruitDetails.length === 0 ? (
                  <span style={{ marginLeft: "35px", marginBottom: "20px", fontSize: 'medium' }}>You have not recruited any trainer at the moment.</span>
                ) : (
                  ""
                )}

                {trainerRecruitDetails.length === 0 ? (
                  ""
                ) : (
                  <Grid container spacing={2}>
                    {renderTrainerCards(trainerRecruitDetails)}
                  </Grid>
                )}

              </div>
            </Grid>
          </Grid>
        </Container>
      </Card>
    </>
  );
};

export default Page;